export const getAuthToken = () => localStorage.getItem('authToken');

export const saveAuthData = (token, user) => {
  localStorage.setItem('authToken', token);
  localStorage.setItem('currentUser', JSON.stringify(user));
};

export const clearAuthData = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('currentUser');
};